module.exports = __webpack_public_path__ + "assets/images/template/project/surgical-mask/correct.jpg?v=85d80223";